import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  ModalCloseButton,
  Flex,
} from '@chakra-ui/react';

const NoFormFieldsModal = ({
  isOpen,
  onClose,
  onGoBack,
  onContinueWithoutFields,
}: {
  isOpen: boolean;
  onClose: () => void;
  onGoBack: () => void;
  onContinueWithoutFields: () => void;
}) => {
  const handleGoBack = () => {
    onGoBack();
    onClose();
  };

  const handleContinue = () => {
    onContinueWithoutFields();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent p={6}>
        <ModalCloseButton />
        <ModalBody>
          <Text textStyle="heading4" textAlign="center" mt={2}>
            No form fields added
          </Text>
          <Flex
            direction="column"
            gap={2}
            mt={4}
            w="100%"
            justifyContent="flex-start"
          >
            <Text textStyle="bodyFamilyRegular" fontSize="16px" mt={2}>
              You haven't added any fields to this form.
            </Text>
            <Text textStyle="bodyFamilyRegular" fontSize="16px">
              How would you like to issue passes?
            </Text>
            <Flex direction="column" gap={2} mt={4}>
              <Text textStyle="bodyFamilyMedium" fontSize="16px">
                Continue without fields?
              </Text>
              <Text textStyle="bodyFamilyRegular" fontSize="16px">
                Issue passes via a shareable link or QR code without collecting
                customer data.
              </Text>
            </Flex>
          </Flex>
          <Flex direction="column" gap={2} mt={6}>
            <Text textStyle="bodyFamilyMedium" fontSize="16px">
              Go back and add form fields
            </Text>
            <Text textStyle="bodyFamilyRegular" fontSize="16px">
              Collect customer information before issuing passes.
            </Text>
          </Flex>
        </ModalBody>
        <ModalFooter justifyContent="center" gap={4} mt={4}>
          <Button variant="outline" onClick={handleGoBack}>
            Go back
          </Button>
          <Button variant="gradient" onClick={handleContinue}>
            Continue without fields
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NoFormFieldsModal;
